import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    AnimateModuleName,
    CustomerServiceModuleName,
    LoggingFundedModuleName,
    LqbPricerLogModuleName,
    LqbPricerParamsServiceModuleName,
    SortablePaginationModuleName,
    UserServiceModuleName,
    VAccordionModuleName
} from "../utils/names/optionalModuleNames";
import {NavigationItem} from "../main/model/navigationItem";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {LqbFundedLogsControllerName} from "../utils/names/controllerNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";
import {getTabName} from "modules/utils/TabNameUtils";

export const LqbFundedLogModuleConfiguration = new RestrictedRouteModuleConfiguration(
    UserGranredAuthorityName.LOGGING_FUNDED,
    [
        SortablePaginationModuleName,
        LoggingFundedModuleName,
        CustomerServiceModuleName,
        LqbPricerParamsServiceModuleName,
        LqbPricerLogModuleName,
        AngularJsMaterialModuleName,
        VAccordionModuleName,
        AnimateModuleName,
        UserServiceModuleName
    ],
    [
        ["/logging/lqb", {
            template: require("./route/funded-logging.html"),
            controller: LqbFundedLogsControllerName
        }]
    ],
    [
        new NavigationItem({
            title: 'Syncing',
            href: '#!logging/lqb',
            activeFunction: routeName => routeName.indexOf("logging") !== -1 && routeName.indexOf("lqb") !== -1
        })
    ],
    [LoggingFundedModuleName],
    [UserGranredAuthorityName.LOGGING_FUNDED],
    getTabName() + '| Syncing'
);

export default LqbFundedLogModuleConfiguration;